import React from 'react'

import * as S from './AnalyticsTooltipContent.styled'

export type AnalyticsTooltipContentProps = {
  title?: string
  description: string
  formula?: string
}

export const AnalyticsTooltipContent = ({
  title,
  description,
  formula,
}: AnalyticsTooltipContentProps) => {
  return (
    <S.Container>
      {title && <S.Title>{title}</S.Title>}
      <S.Description>{description}</S.Description>
      {formula && <S.Formula>{formula}</S.Formula>}
    </S.Container>
  )
}
